// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3pUVQ","footer":"ModalError_footer__3vDSv"};